<template>
  <div>
    <div class="filter">
      <el-form
        :inline="true"
        @submit.native.prevent
        :model="filter"
        ref="filterForm"
        label-position="right"
        label-width="80px"
        class="oneline"
        size="small"
      >
        <el-form-item label="成品分类">
          <ProductTemplateSelect
            v-model="filter.product_template_id"
            :category="category"
            :clearable="true"
          ></ProductTemplateSelect>
        </el-form-item>
        <el-form-item label="规格型号">
          <el-input v-model="filter.model_number"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- <div style="display: flex; justify-content: end">
      <file-button
        obj="hour_step_product"
        :filter="queryData"
        exportBtnName="导出明细"
        :importButton="false"
      ></file-button>
    </div> -->
    <MyTable
      :items="items.list"
      :category="category"
      v-loading="loading"
    ></MyTable>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData()"
      layout="total, prev, pager, next"
      :total="items.count"
    ></el-pagination>
  </div>
</template>

<script>
import { productStatistics } from '@/service/getData'
import MyTable from './table'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    MyTable,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.category = this.category
      data.is_data_hour_step = true
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        product_template_id: '',
        model_number: '',
        page: 1,
        size: 10,
        tab: 'hour_step_data',
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      if (filter.tab == 'hour_step_data') {
        this.filter = filter
      }
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.product_template_id = ''
        this.filter.model_number = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await productStatistics(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>